import {Component, OnInit} from 'ng-metadata/core';
import {ScrollService} from './scroll.service';

@Component({
    selector: 'prm-scroll',
    templateUrl: 'components/search/scroller/scroll.html',
})

export class PrmScroll implements OnInit{
    constructor(private scrollService: ScrollService) {
    }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/scroller/scroll.directive.ts